import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import getFormattedHour from 'presentation/modules/booking/shared/utils/getFormattedHour';
import {useBeneficiaryCard} from 'presentation/hooks/useBeneficiaryCard';

export function useTelehealthReviewBookingNew() {
	const bookingData = useBookingStore(state => state.bookingData);
	const {beneficiaryCardPlanData} = useBeneficiaryCard();

	const hour = getFormattedHour(bookingData.hourAt, FlowEnum.TELEHEALTH);

	return {
		beneficiaryName: beneficiaryCardPlanData.userName,
		planName: beneficiaryCardPlanData.planName,
		providerName: bookingData.professionalName,
		specialtyName: bookingData.specialtyName,
		date: bookingData.dateAt,
		hour,
	};
}
